import Vue from 'vue'
// Import the CommonJS build to avoid ESM named-export issues with some bundlers
// The package provides `vue-i18n.common.js` under dist; import that file directly.
import VueI18n from 'vue-i18n/dist/vue-i18n.common.js'
import el from '@/locales/el.json'
import en from '@/locales/en.json'

Vue.use(VueI18n)

const messages = {
    en,
    el
}

const i18n = new VueI18n({
    locale: 'el',
    fallbackLocale: 'en',
    messages
})

export default i18n
